module.exports = __webpack_public_path__ + "img/65293383001401.f2c48a00.png";